export default "// Type your solution below\n";